import React from 'react';

interface ITimer {
    isExpired: boolean;
    days: number
    minutes: number;
    seconds: number;
    hours: number;
}

const ShortDaysLeft = ({ isExpired, days, minutes, seconds, hours }: ITimer) => {
    return (
        <>
            {isExpired || (minutes === 0 && seconds === 0 && hours === 0 && days === 0) ?
                <></>
                :
                <>
                    { days > 0 &&
                        <>
                            {(days).toString()} {days === 1 ? 'Day' : 'Days'} Left
                        </>
                    }
                    { days === 0  &&
                        <>
                            <span className="">Ends Today</span>
                        </>
                    }

                </>
            }
        </>
    )
};

export default ShortDaysLeft;